export default {
    //filterlist para servicios
    //cambiar myRecords por el filterlist en cuanto haya un servicio y eliminar este comentario.
    myRecords: 12345,
    myChannels: 31433,
    myFavorites: 31432,
};



// WEBPACK FOOTER //
// ./src/containers/MyContent/settings.js